import React, { useState, useEffect, useMemo } from 'react';
import { API, authFetch } from '../utils/api';

function DashboardDocAgency({ user }) {
  var [data, setData] = useState(null);
  var [loading, setLoading] = useState(true);
  var [search, setSearch] = useState('');
  var [sortKey, setSortKey] = useState('companyName');
  var [sortDir, setSortDir] = useState('asc');
  var [alertFilter, setAlertFilter] = useState('all');
  var [notices, setNotices] = useState([]);
  var [dismissedNotices, setDismissedNotices] = useState(function(){try{return JSON.parse(sessionStorage.getItem('dismissed_notices')||'[]')}catch(e){return[]}});

  useEffect(function() {
    authFetch(API + '/dashboard/doc-agency')
      .then(function(r) { return r.json(); })
      .then(function(d) { setData(d); setLoading(false); })
      .catch(function() { setLoading(false); });
    authFetch(API + '/dashboard/notices').then(function(r){return r.json()}).then(function(d){setNotices(Array.isArray(d)?d:[])}).catch(function(){});
  }, []);

  var handleSort = function(key) {
    if (sortKey === key) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  var filteredCompanies = useMemo(function() {
    if (!data || !data.companies) return [];
    var rows = data.companies.filter(function(c) {
      if (!search) return true;
      var q = search.toLowerCase();
      return (c.companyName || '').toLowerCase().indexOf(q) >= 0 ||
             (c.bizNo || '').indexOf(q) >= 0 ||
             (c.ceo || '').toLowerCase().indexOf(q) >= 0;
    });
    rows.sort(function(a, b) {
      var av = a[sortKey];
      var bv = b[sortKey];
      if (typeof av === 'string') av = (av || '').toLowerCase();
      if (typeof bv === 'string') bv = (bv || '').toLowerCase();
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
    return rows;
  }, [data, search, sortKey, sortDir]);

  var filteredAlerts = useMemo(function() {
    if (!data || !data.alerts) return [];
    if (alertFilter === 'all') return data.alerts;
    return data.alerts.filter(function(a) { return a.level === alertFilter; });
  }, [data, alertFilter]);

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', color: '#64748b' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 32, marginBottom: 12, animation: 'spin 1s linear infinite' }}>Loading...</div>
      </div>
    </div>
  );

  if (!data) return <div style={{ padding: 24, color: '#dc2626' }}>데이터 로드 실패</div>;

  var s = data.summary || {};
  var tasks = data.todayTasks || {};

  var fmtMoney = function(v) {
    if (!v) return '-';
    return Number(v).toLocaleString() + '원';
  };

  var sortArrow = function(key) {
    if (sortKey !== key) return ' ↕';
    return sortDir === 'asc' ? ' ↑' : ' ↓';
  };

  var handleCompanyClick = function(companyId) {
    // 격리: 업체 선택 → 해당 업체로 전환 후 차량 목록으로 하드 이동 (옛 회사 React state 강제 폐기)
    authFetch(API + '/auth/switch-company', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ companyId: companyId })
    }).then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) {
        localStorage.setItem('autodoc_token', d.token);
        if(d.user)sessionStorage.setItem('autodoc_user',JSON.stringify(d.user));
        window.location.href = '/main/car-list';
      }
    }).catch(function() {});
  };

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1400, margin: '0 auto' }}>
      {/* 공지사항 배너 */}
      {notices.filter(function(n){return dismissedNotices.indexOf(n.id)===-1}).map(function(n){
        var ps={info:{bg:'#eff6ff',bl:'#3b82f6',c:'#1e40af',icon:'🔵'},warning:{bg:'#fffbeb',bl:'#f59e0b',c:'#92400e',icon:'🟡'},urgent:{bg:'#fef2f2',bl:'#ef4444',c:'#991b1b',icon:'🔴'}};
        var st=ps[n.priority]||ps.info;
        return(<div key={n.id} style={{background:st.bg,borderLeft:'4px solid '+st.bl,borderRadius:8,padding:'10px 16px',marginBottom:10,display:'flex',alignItems:'center',gap:10}}>
          <span style={{fontSize:16}}>{st.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontWeight:700,fontSize:13,color:st.c}}>{n.title}</div>
            {n.content&&<div style={{fontSize:12,color:'#666',marginTop:2}}>{n.content}</div>}
          </div>
          <span style={{fontSize:10,color:'#94a3b8',whiteSpace:'nowrap'}}>{(n.createdAt||'').slice(0,10)}</span>
          <button onClick={function(){var updated=dismissedNotices.concat(n.id);setDismissedNotices(updated);try{sessionStorage.setItem('dismissed_notices',JSON.stringify(updated))}catch(e){}}} style={{background:'none',border:'none',fontSize:14,cursor:'pointer',color:'#94a3b8',padding:2}}>✕</button>
        </div>);
      })}
      {/* Summary Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <SummaryCard icon="🏢" label="관리 업체 수" value={s.companyCount || 0} unit="개" color="#1B3A5C" />
        <SummaryCard icon="🚗" label="전체 차량 수" value={s.totalCars || 0} unit="대" color="#2563eb" />
        <SummaryCard icon="✅" label="이번 달 처리 완료" value={s.completedThisMonth || 0} unit="대" color="#16a34a" />
        <SummaryCard icon="🚨" label="미처리 긴급" value={s.urgentCount || 0} unit="건" color="#dc2626" urgent={s.urgentCount > 0} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 360px', gap: 20 }}>
        {/* Left: Company Table */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1B3A5C' }}>업체별 현황</h3>
            <input
              type="text"
              placeholder="업체명 / 사업자번호 검색..."
              value={search}
              onChange={function(e) { setSearch(e.target.value); }}
              style={{ padding: '7px 14px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13, width: 240, outline: 'none' }}
            />
          </div>
          <div style={{ overflowX: 'auto', maxHeight: 'calc(100vh - 340px)', overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                  {[
                    { key: 'companyName', label: '업체명', w: 140 },
                    { key: 'carCount', label: '차량 수', w: 70 },
                    { key: 'registered', label: '등록완료', w: 70 },
                    { key: 'cancelWait', label: '말소대기', w: 70 },
                    { key: 'clearanceWait', label: '면장대기', w: 70 },
                    { key: 'deadlineUrgent', label: '기한임박', w: 70 },
                    { key: 'unpaid', label: '미수금', w: 100 },
                    { key: 'latestActivity', label: '최근활동', w: 90 }
                  ].map(function(col) {
                    return (
                      <th key={col.key}
                        onClick={function() { handleSort(col.key); }}
                        style={{ padding: '10px 8px', textAlign: col.key === 'companyName' ? 'left' : 'center', fontWeight: 600, color: '#475569', cursor: 'pointer', whiteSpace: 'nowrap', borderBottom: '2px solid #1B3A5C', minWidth: col.w, userSelect: 'none', fontSize: 12 }}>
                        {col.label}{sortArrow(col.key)}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {filteredCompanies.length === 0 ? (
                  <tr><td colSpan={8} style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>검색 결과 없음</td></tr>
                ) : filteredCompanies.map(function(co) {
                  var hasUrgent = co.deadlineUrgent > 0;
                  return (
                    <tr key={co.companyId}
                      style={{ background: hasUrgent ? '#fef2f2' : '#fff', borderBottom: '1px solid #f1f5f9', transition: 'background 0.15s' }}
                      onMouseEnter={function(e) { if (!hasUrgent) e.currentTarget.style.background = '#f8fafc'; }}
                      onMouseLeave={function(e) { e.currentTarget.style.background = hasUrgent ? '#fef2f2' : '#fff'; }}>
                      <td style={{ padding: '10px 8px' }}>
                        <span
                          onClick={function() { handleCompanyClick(co.companyId); }}
                          style={{ color: '#2563eb', fontWeight: 600, cursor: 'pointer', textDecoration: 'none' }}
                          onMouseEnter={function(e) { e.target.style.textDecoration = 'underline'; }}
                          onMouseLeave={function(e) { e.target.style.textDecoration = 'none'; }}>
                          {co.companyName}
                        </span>
                      </td>
                      <td style={{ padding: '10px 8px', textAlign: 'center', fontWeight: 600 }}>{co.carCount}</td>
                      <td style={{ padding: '10px 8px', textAlign: 'center' }}>{co.registered || '-'}</td>
                      <td style={{ padding: '10px 8px', textAlign: 'center' }}>{co.cancelWait || '-'}</td>
                      <td style={{ padding: '10px 8px', textAlign: 'center' }}>{co.clearanceWait || '-'}</td>
                      <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                        {co.deadlineUrgent > 0
                          ? <span style={{ background: '#dc2626', color: '#fff', borderRadius: 10, padding: '2px 8px', fontSize: 11, fontWeight: 700 }}>{co.deadlineUrgent}</span>
                          : <span style={{ color: '#94a3b8' }}>-</span>}
                      </td>
                      <td style={{ padding: '10px 8px', textAlign: 'right', fontSize: 12 }}>
                        {co.unpaid > 0
                          ? <span style={{ color: '#dc2626', fontWeight: 600 }}>{fmtMoney(co.unpaid)}</span>
                          : <span style={{ color: '#94a3b8' }}>-</span>}
                      </td>
                      <td style={{ padding: '10px 8px', textAlign: 'center', color: '#64748b', fontSize: 12 }}>{co.latestActivity}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* Right: Side Panel */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* Urgent Alerts */}
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
            <div style={{ padding: '14px 16px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h4 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#dc2626' }}>긴급 알림</h4>
              <div style={{ display: 'flex', gap: 4 }}>
                {[
                  { key: 'all', label: '전체' },
                  { key: 'urgent', label: '긴급' },
                  { key: 'warn', label: '주의' }
                ].map(function(f) {
                  return (
                    <button key={f.key}
                      onClick={function() { setAlertFilter(f.key); }}
                      style={{ padding: '3px 10px', borderRadius: 12, border: 'none', fontSize: 11, fontWeight: 600, cursor: 'pointer', background: alertFilter === f.key ? '#1B3A5C' : '#f1f5f9', color: alertFilter === f.key ? '#fff' : '#64748b' }}>
                      {f.label}
                    </button>
                  );
                })}
              </div>
            </div>
            <div style={{ maxHeight: 320, overflowY: 'auto', padding: '8px 12px' }}>
              {filteredAlerts.length === 0 ? (
                <div style={{ padding: 20, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>알림 없음</div>
              ) : filteredAlerts.map(function(a) {
                var bgColor = a.level === 'urgent' ? '#fef2f2' : a.level === 'warn' ? '#fffbeb' : '#f0f9ff';
                var borderColor = a.level === 'urgent' ? '#fca5a5' : a.level === 'warn' ? '#fde68a' : '#bae6fd';
                return (
                  <div key={a.id} style={{ padding: '8px 10px', marginBottom: 6, borderRadius: 8, background: bgColor, border: '1px solid ' + borderColor, fontSize: 12 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <span>{a.icon} {a.text}</span>
                    </div>
                    <div style={{ fontSize: 11, color: '#64748b', marginTop: 3 }}>{a.companyName}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Today Tasks */}
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
            <div style={{ padding: '14px 16px', borderBottom: '1px solid #e5e7eb' }}>
              <h4 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1B3A5C' }}>오늘 할 일</h4>
            </div>
            <div style={{ padding: '12px 16px' }}>
              {/* Departure today */}
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 6 }}>
                  출발 예정 차량 <span style={{ color: '#2563eb' }}>({(tasks.departureToday || []).length})</span>
                </div>
                {(tasks.departureToday || []).length === 0 ? (
                  <div style={{ fontSize: 12, color: '#94a3b8', paddingLeft: 8 }}>없음</div>
                ) : (tasks.departureToday || []).slice(0, 5).map(function(c) {
                  return (
                    <div key={c.carId} style={{ fontSize: 12, padding: '4px 8px', display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ fontWeight: 600 }}>{c.carNo}</span>
                      <span style={{ color: '#64748b' }}>{c.companyName}</span>
                    </div>
                  );
                })}
              </div>

              {/* Clearance ready */}
              <div>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 6 }}>
                  면장 신청 대기 <span style={{ color: '#ea580c' }}>({(tasks.clearanceReady || []).length})</span>
                </div>
                {(tasks.clearanceReady || []).length === 0 ? (
                  <div style={{ fontSize: 12, color: '#94a3b8', paddingLeft: 8 }}>없음</div>
                ) : (tasks.clearanceReady || []).slice(0, 5).map(function(c) {
                  return (
                    <div key={c.carId} style={{ fontSize: 12, padding: '4px 8px', display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ fontWeight: 600 }}>{c.carNo}</span>
                      <span style={{ color: '#64748b' }}>{c.companyName}</span>
                    </div>
                  );
                })}
                {(tasks.clearanceReady || []).length > 5 && (
                  <div style={{ fontSize: 11, color: '#2563eb', paddingLeft: 8, marginTop: 4 }}>
                    +{(tasks.clearanceReady || []).length - 5}건 더...
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SummaryCard({ icon, label, value, unit, color, urgent }) {
  return (
    <div style={{
      background: urgent ? '#fef2f2' : '#fff',
      borderRadius: 12,
      border: '1px solid ' + (urgent ? '#fca5a5' : '#e5e7eb'),
      padding: '18px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      transition: 'box-shadow 0.2s',
      boxShadow: urgent ? '0 0 0 2px #dc2626' : 'none'
    }}>
      <div style={{ fontSize: 28, width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', background: (urgent ? '#fee2e2' : color + '12'), borderRadius: 12 }}>
        {icon}
      </div>
      <div>
        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 2 }}>{label}</div>
        <div style={{ fontSize: 26, fontWeight: 800, color: urgent ? '#dc2626' : color, lineHeight: 1 }}>
          {Number(value).toLocaleString()}<span style={{ fontSize: 14, fontWeight: 500, marginLeft: 2, color: '#94a3b8' }}>{unit}</span>
        </div>
      </div>
    </div>
  );
}

export default DashboardDocAgency;
